import { TTypeOfCodec } from "../../shared/src/codecs/codec";
import { required } from "../../shared/src/codecs/types/required";
import { string } from "../../shared/src/codecs/types/string";
import { CasesLenderNameOnPanel1 } from "./CasesLenderNameOnPanel";

export const Lender = required({
    lender_name: CasesLenderNameOnPanel1,
    panel_number: string(),
});
export type TLenderCodec = typeof Lender;
export type TLender = TTypeOfCodec<TLenderCodec>;
